<footer class="site-footer">
  <div class="footer-inner">
    <span class="footer-brand">
      <img src="favicon.svg?v=2" alt="" width="20" height="20">
      Memory
    </span>
    <span>© {{date}} · <a href="https://marufh.com" target="_blank" rel="noopener">marufh.com</a></span>
  </div>
</footer>
